import React, { Component } from 'react';
import CurrentOrderStore from '../store/CurrentOrderStore';

const currentOrderDb = new CurrentOrderStore('currentOrderDb');

export const withCurrentOrder = (WrappedComponent) => class WithCurrentOrder extends Component {
    state = {
      currentOrderId: null,
    };

    load = () => {
      currentOrderDb.getCurrentOrder((currentOrder) => {
        if (!currentOrder) {
          return;
        }

        this.setState({ currentOrderId: currentOrder.orderId });
      });
    };

    setCurrentOrder = (id) => {
      currentOrderDb.setCurrentOrder(id, this.load);
    };

    render() {
      return (
        <WrappedComponent
          currentOrder={{
            value: this.state.currentOrderId,
            setCurrentOrder: this.setCurrentOrder,
            load: this.load,
          }}
          {...this.props}
        />
      );
    }
};

export default withCurrentOrder;
